<mat-form-field class="w-100" [appearance]="appearance" [ngClass]="getInputClass()"
  [subscriptSizing]="!formControl.errors && hintMaxLength ? 'dynamic': 'fixed'">
    <mat-label *ngIf="label">{{label}}</mat-label>
    <input
      matInput
      autocomplete="off"
      [formControl]="formControl"
      [type]="type"
      [smataClientNgAttr]="label"
      [maxlength]="maxlength && hintMaxLength ? hintMaxLength : maxlength"
      (focus)="onFocus()"
      (blur)="handleBlur($event)"
      (keydown)="onKeyDown($event)"
      [placeholder]="placeholder"
      [ngClass]="{'number-arrows-hidden': !showNumberArrows}"
      />
    <span matTextPrefix class="smata-pr-8" *ngIf="prefixCondition">
        {{prefix}}
    </span>
    <span matTextSuffix *ngIf="suffix" class="pr-2">{{suffix}}</span>
    <mat-icon matSuffix *ngIf="icon" class="{{icon}}">{{icon}}</mat-icon>
    <mat-hint *ngIf="hintMaxLength > 0" align="end">{{textLength}}/{{hintMaxLength}}</mat-hint>
</mat-form-field>
<div #errorArea>
    <ng-content select="mat-error,ng-container"></ng-content>
</div>
